import { fetchJson } from "./httpClient";
import { AuthClient } from "@supabase/auth-js";

// auth-js keeps the session under this key, and httpClient.js sends its raw
// value (the whole session JSON) as the bearer token.
export const SESSION_KEY = "access_token";

export const auth = new AuthClient({
  url: "/auth/v1",
  storageKey: SESSION_KEY,
});

// Signs out at the server, then always drops the local session.
//
// GoTrue replies 403 session_not_found once its own session row has been
// revoked (eg. by a logout in another tab) or pruned, and auth-js reports that
// as an error *without* clearing the local session. Swallowing it here
// lets Log Out work no matter how stale the local session is.
export const logout = async () => {
  const { error } = await auth.signOut();
  if (error) {
    console.warn("Sign out at auth server failed:", error.message);
    // Same keys auth-js's private _removeSession() would have cleared
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(`${SESSION_KEY}-user`);
    localStorage.removeItem(`${SESSION_KEY}-code-verifier`);
  }
};

export const authProvider = {
  login: async ({ username, password }) => {
    // Login is handled outside the authProvider
    return;
  },

  logout: async () => {
    await logout();
    window.location.replace("/login");
  },

  checkError: (error) => {
    // If an API call fails with 401, then consider us logged out
    const status = error.status;
    if (status === 401) {
      authProvider.logout();
      return Promise.reject();
    }
    return Promise.resolve();
  },

  checkAuth: async () => {
    const session = auth.getSession();
    if (!session) {
      throw new Error("Not logged in");
    }
  },
  getPermissions: () => {
    // Assume we have all permissions in RA
    return Promise.resolve();
  },
};

let userinfo;

// Called once to check login and gather userinfo
export async function validateLogin() {
  try {
    userinfo = (await fetchJson("/api/v2/userinfo")).json;
  } catch (error) {
    // This is expected to fail if the session has expired
  }
  console.log("validateLogin complete");
}

export function isValidated() {
  if (userinfo) {
    return true;
  }
  return false;
}

export function getCustomerAssociations() {
  if (userinfo) {
    return userinfo.user.customerAssociations;
  }
}

// A list of scopes that are defined in our server
export const SCOPE = {
  ADMIN: "admin",
  TECHNICIAN: "?-technician",
  MANAGER: "?-manager",
  MEMBER: "?-member",
  DIAGNOSTICS: "diagnostics",
};

export function setScopesCustomerID(custID) {
  SCOPE.TECHNICIAN = custID + "-technician";
  SCOPE.MANAGER = custID + "-manager";
  SCOPE.MEMBER = custID + "-member";
}

// Searches the user's scopes to determine if they have a given one.
// In general you only have to check for the lowest allowable priviledge:
//    * ADMIN trumps all
//    * If a user has MANAGER or TECHNICIAN, then they will also have the lower scopes listed as well.
export function hasScope(p) {
  if (userinfo === undefined) {
    return false;
  }

  let ret = false;
  userinfo.scopes.forEach((s) => {
    if (s === p || s === SCOPE.ADMIN) {
      ret = true;
    }
  });
  return ret;
}
